import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const ob = {
  Id: null,
  DirectTrust: false,
  IDProofingRequired: false,
  TrustedAgentAgreement: false,
  TwoFactorAuth: false,
  ApplicationAccessSESConnect: false,
  DirectorySharing: false,
  ApplicationAccessXDR: false,
  ApplicationAccessENS: false,
  RegistrationAPIActive: false,
  EmailForwardingTypeBox: false,
  EmailForwardingType: false,
  DirectRoute: false,
  GatewayModeEnabled: false,
};

const DetailsCustomer = ({ userDetails, userEdit }) => {
  const navigate = useNavigate();
  const { userToken, setCustomerObj, SetSharedObject, setSearchObj, backendTarget } =
    useUserStore((state) => ({
      userToken: state.userToken,
      setCustomerObj: state.setCustomerObj,
      SetSharedObject: state.SetSharedObject,
      setSearchObj: state.setSearchObj,
      backendTarget: state.backendTarget,
    }));

  // GCP backend does not support DirectTrust / CHSConnect / Notify — hide them and
  // exclude them from update.
  const isGcp = backendTarget === "gcp";
  const [answers, setAnswers] = useState(null);
  const [successFlag, setSuccessFlag] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [checkBoxes, setCheckBoxes] = useState(null);
  const [processing, setProcessing] = useState(false);
  const closeButtonRef = useRef(null);
  const triggerRef = useRef(null);

  const setAnswer = async (questionId, answer) => {
    if (questionId === "EmailForwardingTypeBox") {
      if (answer) {
        checkBoxes.EmailForwardingType = 2;
      } else {
        checkBoxes.EmailForwardingType = 0;
      }
    } else if (questionId === "DirectRoute") {
      if (answer) {
        checkBoxes.EmailForwardingType = 1;
      } else {
        checkBoxes.EmailForwardingType = 0;
      }
    }
    await setCheckBoxes({ ...checkBoxes, [questionId]: answer });
  };

  const ViewCustomer = (row) => {
    SetSharedObject("CustomerPermissionsObj", row);
    row.Flag = "customer";
    row.Navigate = "customer";
    row.Name = row.name;
    setCustomerObj(row);
    SetSharedObject("UserIdEmail", row);
    setSearchObj({});
    CloseModal();
    navigate("/organizations");
  };
  useEffect(() => {
    SetErrMsg(false);
    let o = {};
    if (userDetails) {
      o = {
        Id: userDetails.id,
        DirectTrust: userDetails.directTrust,
        IDProofingRequired: userDetails.idProofingRequired,
        TrustedAgentAgreement: userDetails.trustedAgentAgreement,
        TwoFactorAuth: userDetails.twoFactorAuth,
        ApplicationAccessSESConnect: userDetails.applicationAccessSESConnect,
        DirectorySharing: userDetails.directorySharing,
        ApplicationAccessXDR: userDetails.applicationAccessXDR,
        ApplicationAccessENS: userDetails.applicationAccessENS,
        RegistrationAPIActive: userDetails.registrationAPIActive,
        EmailForwardingTypeBox:
          userDetails.emailForwardingType === 2 ? true : false,
        EmailForwardingType: userDetails.emailForwardingType,
        DirectRoute: userDetails.emailForwardingType === 1 ? true : false,
        GatewayModeEnabled: userDetails.gatewayModeEnabled,
      };
    }
    setCheckBoxes(o);
    setAnswers(userDetails);
    setSuccessFlag(false);
    setSubmitFlag(false);
    return () => {
      setCheckBoxes(null);
      SetErrMsg(false);
      setCheckBoxes(ob);
    };
  }, [userDetails]);

  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const UpdateCustomer = async () => {
    setSuccessFlag(false);
    SetErrMsg(false);
    if (
      checkBoxes.RegistrationAPIActive &&
      checkBoxes.IDProofingRequired === true &&
      checkBoxes.TrustedAgentAgreement === false
    ) {
      SetMsg(
        "Registration API is not allowed without TA Agreement when IDProofing is required."
      );
      SetErrMsg(true);
      return;
    }
    if (!isGcp && checkBoxes.DirectTrust && checkBoxes.IDProofingRequired === false) {
      SetMsg("ID Proofing is required for DirectTrust.");
      SetErrMsg(true);
      return;
    }
    if (
      checkBoxes.IDProofingRequired === false &&
      checkBoxes.TrustedAgentAgreement
    ) {
      SetMsg("Trusted Agent Agreement is not allowed without ID Proofing.");
      SetErrMsg(true);
      return;
    }
    if (
      !isGcp &&
      checkBoxes.RegistrationAPIActive &&
      !checkBoxes.ApplicationAccessSESConnect
    ) {
      SetMsg("Registration API  not allowed without CHSConnect license.");
      SetErrMsg(true);
      return;
    }
    setSubmitFlag(true);
    setProcessing(true);
    let call = "/customers/UpdateCustomer";
    const payload = isGcp
      ? {
          // GCP backend does not support these — never send them as enabled.
          ...checkBoxes,
          DirectTrust: false,
          ApplicationAccessSESConnect: false,
          ApplicationAccessENS: false,
        }
      : checkBoxes;
    const res = await CallAPI(call, payload, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      await getCustomers();
      setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      SetMsg(
        "Customer cannot be updated at this time. Please contact customer support for further assistance."
      );
      SetErrMsg(true);
      setProcessing(false);
    }
  };
  const getCustomers = async () => {
    setProcessing(true);
    let call = "/users/GetVendors";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      SetSharedObject("vendorsObj", res.data.data);
      SetSharedObject("refreshCustObj", Date.now());
    } else if (res.status === "SERVERERROR") {
      SetMsg(
        "An Error Occurred. Please contact customer support for further assistance."
      );
      SetErrMsg(true);
      setProcessing(false);
    }
  };
  function setSesConnect(val) {
    if (val === true) {
      setCheckBoxes({ ...checkBoxes, ApplicationAccessSESConnect: val });
      setAnswers({ ...answers, ApplicationAccessSESConnect: val });
    } else {
      setCheckBoxes({
        ...checkBoxes,
        RegistrationAPIActive: val,
        ApplicationAccessSESConnect: val,
      });
      setAnswers({
        ...answers,
        ApplicationAccessSESConnect: val,
        RegistrationAPIActive: val,
      });
    }
  }

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  useEffect(() => {
      const modal = document.getElementById("detailsCustomerModal");
      const handleShown = () => closeButtonRef.current?.focus();
      modal?.addEventListener("shown.bs.modal", handleShown);
      return () => modal?.removeEventListener("shown.bs.modal", handleShown);
    }, []);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

      $('#detailsCustomerModal').modal('hide');
      setSuccessFlag(false);
      triggerRef.current?.focus();
};
 
  return (
    <div className="DetailsCustomer">
      <div
        className="modal fade"
        id="detailsCustomerModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="detailsCustomerModalTitle"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="detailsCustomerModalTitle"
                tabIndex={0}
              >
                Details
              </h2>
              <button
                type="button"
                className="close"
                onClick={CloseModal}
                aria-label="Close dialog"
                ref={closeButtonRef}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form aria-label="Customer details and permissions">
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <i className="bi bi-buildings-fill text-size5" aria-hidden="true"></i>
                    <div className="text-size6 ft-wt blk-clr">
                      {answers?.name}
                    </div>
                    <div className="sp-margin1">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={(el) => {
                          userEdit(answers);
                          el.preventDefault();
                        }}
                        aria-label={ `Edit ${answers?.name}` }
                      >
                        <i 
                            className="bi bi-pencil-square sp-margin5" 
                            aria-hidden="true">
                        </i>
                        EDIT
                      </button>
                    </div>
                  </div>
                  <dl>
                  <dt className="v-top">Address:</dt>
                    <dd>
                        <address>
                            {answers?.billingAddress?.street1} {" "}
                            {answers?.billingAddress?.street2}, {" "}
                            {answers?.billingAddress?.city}, {" "}
                            {answers?.billingAddress?.state} {" "}
                            {answers?.billingAddress?.country} {" "}
                            {answers?.billingAddress?.zip}
                      </address>
                    </dd>
                    <div>
                      <dt>Phone:</dt>
                      <dd className="sp-margin5 ">
                          {answers?.billingAddress?.phone ? (
                            <a
                                href={`tel:${answers.billingAddress.phone.substring(0, 10)}`}
                                aria-label={`Call phone number ${formatPhoneNumber(answers.billingAddress.phone.substring(0, 10))}`}
                            >
                                {formatPhoneNumber(answers.billingAddress.phone.substring(0, 10))}
                            </a>
                          ) : null}
                      </dd>{" "}
                      <dt className="sp-margin5 ">Ext:</dt>
                      <dd >
                        {answers?.billingAddress?.phone?.substring(
                          10,
                          answers?.billingAddress?.phone.length
                        )}
                      </dd>
                    </div>
                    <div>
                      <dt>Fax:</dt>
                      <dd className="sp-margin5 spacer-inline">
                        {formatPhoneNumber(
                          answers?.billingAddress?.fax?.substring(0, 10)
                        )}
                      </dd>{" "}
                      <dt className="sp-margin5">Ext:</dt>
                      <dd>
                        {answers?.billingAddress?.fax?.substring(
                          10,
                          answers?.billingAddress?.fax.length
                        )}
                      </dd>
                    </div>
                  </dl>
                  <hr />

                  {/*Customer Info*/}
                  <fieldset>
                    <legend className="sr-only">Customer Information</legend>
                    <dl>
                        <dt>Domain:</dt>
                        <dd>{answers?.baseDomain?.name}</dd><br />
                        <dt >Total Organizations:</dt>
                        <dd>
                            <button
                                  type="button"
                                  id="TotalOrgs"
                                  underline="none"
                                  className="btn btn-link sp-pad0 font-weight-bold v-set3"
                                  onClick={(el) => {
                                    ViewCustomer(userDetails);
                                    el.preventDefault();
                                  }}
                                  aria-label={`View ${answers?.org ?? 0} organizations for ${answers?.name || "this customer"}`}
                                >
                                  {answers?.org ?? 0}
                                </button>
                        </dd><br />
                        
                        <dt>Created By:</dt>
                        <dd>{answers?.createdBy?.split("|") [0]}</dd><br />
                        <dt>Date Created:</dt>
                        <dd>{answers?.dateCreated}</dd>
                    </dl>
                  </fieldset>

                  {/*Customer Identity Verification*/}
                  <section className="field-wrapper label-divider " id="verificationTitle">
                    <h6 className="sp-margin3 spacer-inline">
                      Verifications
                    </h6>
                  </section>
                  <div className="field-wrapper">
                      {!isGcp && (
                      <div>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          name="DirectTrust"
                          id="DirectTrust"
                          checked={checkBoxes?.DirectTrust}
                          value={checkBoxes?.DirectTrust}
                          onClick={(el) =>
                            setAnswer("DirectTrust", el.target.checked)
                          }
                        />
                        <label htmlFor="DirectTrust" className="spacer-margin8">DirectTrust</label>
                      </div>
                      )}
                      <dd>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          name="IDProofingRequired"
                          id="IDProofingRequired"
                          checked={checkBoxes?.IDProofingRequired}
                          value={checkBoxes?.IDProofingRequired}
                          onClick={(el) =>
                            setAnswer("IDProofingRequired", el.target.checked)
                          }
                        />
                        
                     </dd>
                     <dt className="spacer-margin8">
                          ID Proofing Required
                     </dt><br />
                     <dd>
                        <input
                            type="checkbox"
                            className="spacer-margin5"
                            name="TrustedAgentAgreement"
                            id="TrustedAgentAgreement"
                            checked={checkBoxes?.TrustedAgentAgreement}
                            value={checkBoxes?.TrustedAgentAgreement}
                            onClick={(el) =>
                            setAnswer("TrustedAgentAgreement", el.target.checked)
                            }
                        />
                    </dd>
                    <dt className="spacer-margin8">Trusted Agent</dt>
                  </div>

                  {/*Customers list of services*/}
                  <fieldset className="field-wrapper label-divider">
                    <h6 className="sp-pad9 spacer-inline" id="permissionsTitle">Permissions</h6>
                    <div className="sp-margin3 spacer-inline float-r">
                      <details data-popover="up">
                        <summary aria-label="Permissions Information">
                          <i className="bi bi-info-circle text-size9"></i>
                        </summary>
                        <div role="tooltip">
                          <div className="icon-sign or-clr" aria-hidden="true">
                            <i className="bi bi-info-circle"></i>
                          </div>
                          <p className="sp-margin4">
                            When you set permissions at the customer level, they
                            will become active and can be enabled or disabled at
                            the organization level. If you later deselect these
                            permissions, they will no longer be accessible to
                            any organization.
                          </p>
                        </div>
                      </details>
                    </div>
                  </fieldset>

                  {!isGcp && (
                  <div >
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessSESConnect"
                      id="ApplicationAccessSESConnect"
                      checked={checkBoxes?.ApplicationAccessSESConnect}
                      value={checkBoxes?.ApplicationAccessSESConnect}
                      onClick={(el) => setSesConnect(el.target.checked)}
                    />
                    <label htmlFor="ApplicationAccessSESConnect" className="spacer-margin8">CHSConnect</label>
                    </div>
                  )}
                    {checkBoxes?.ApplicationAccessSESConnect === true ? (
                       <>
                          <dd>
                            <input
                              type="checkbox"
                              className="spacer-margin5"
                              name="RegistrationAPIActive"
                              id="RegistrationAPIActive"
                              checked={checkBoxes?.RegistrationAPIActive}
                              value={checkBoxes?.RegistrationAPIActive}
                              onClick={(el) =>
                                setAnswer(
                                  "RegistrationAPIActive",
                                  el.target.checked
                                )
                              }
                            />
                          </dd>
                          <dt className="spacer-margin8">
                              Registration API
                            </dt><br />
                     </>
                    ) : null}
                    <dd>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectorySharing"
                      id="DirectorySharing"
                      checked={checkBoxes?.DirectorySharing}
                      value={checkBoxes?.DirectorySharing}
                      onClick={(el) =>
                        setAnswer("DirectorySharing", el.target.checked)
                      }
                    />
                   </dd>
                   <dt  className="spacer-margin8">
                      Share Directory Listing
                    </dt><br />
                   <dd>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectRoute"
                      id="DirectRoute"
                      checked={checkBoxes?.DirectRoute}
                      value={checkBoxes?.DirectRoute}
                      disabled={checkBoxes?.EmailForwardingTypeBox}
                      onClick={(el) =>
                        setAnswer("DirectRoute", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">DirectRoute</label>
                    </dd>
                     <div>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="EmailForwardingTypeBox"
                      id="EmailForwardingTypeBox"
                      checked={checkBoxes?.EmailForwardingTypeBox}
                      value={checkBoxes?.EmailForwardingTypeBox}
                      disabled={checkBoxes?.DirectRoute}
                      onClick={(el) =>
                        setAnswer("EmailForwardingTypeBox", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">
                      Advanced DirectRoute
                    </label>
                    </div>
                    {!isGcp && (
                    <div>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessENS"
                      id="ApplicationAccessENS"
                      checked={checkBoxes?.ApplicationAccessENS}
                      value={checkBoxes?.ApplicationAccessENS}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessENS", el.target.checked)
                      }
                    />
                    <label htmlFor="ApplicationAccessENS" className="spacer-margin8">Notify</label>
                    </div>
                    )}
                    <div>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessXDR"
                      id="ApplicationAccessXDR"
                      checked={checkBoxes?.ApplicationAccessXDR}
                      value={checkBoxes?.ApplicationAccessXDR}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessXDR", el.target.checked)
                      }
                    />
                    <label htmlFor="ApplicationAccessXDR" className="spacer-margin8">XDR-Access</label>
                    </div>
                    <div>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="AllowTwoFactor"
                      id="AllowTwoFactor"
                      checked={checkBoxes?.TwoFactorAuth}
                      value={checkBoxes?.TwoFactorAuth}
                      onClick={(el) =>
                        setAnswer("TwoFactorAuth", el.target.checked)
                      }
                    />
                    <label htmlFor="AllowTwoFactor" className="spacer-margin8">
                      Two Factor Authentication
                    </label>
                    </div>
                    <div>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="GatewayModeEnabled"
                      id="GatewayModeEnabled"
                      checked={checkBoxes?.GatewayModeEnabled}
                      value={checkBoxes?.GatewayModeEnabled}
                      onClick={(el) =>
                        setAnswer("GatewayModeEnabled", el.target.checked)
                      }
                    />
                    <label htmlFor="GatewayModeEnabled" className="spacer-margin8">Gateway Mode</label>
                  </div>
                  {errMsg ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                      {msg}
                    </div>
                  ) : null}
                  {submitFlag && successFlag ? (
                    <div className="alert alert-success" role="alert" aria-live="polite" aria-atomic="true">
                      Customer has been updated successfully.
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={UpdateCustomer}
                  aria-busy={ processing }
                  disabled={ processing }
                >
                  {processing ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  disabled={processing}
                  onClick={CloseModal}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {processing && (
        <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="detail-customer-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="detail-customer-loader">{loadingText}</div>
        </div>
      )}
    </div>
  );
};

export default DetailsCustomer;
